module.exports = __webpack_public_path__ + "images/04321b27942450aabfc28955f1aa33c9.jpg";